import { usePreviewContext } from 'context/previewContext'
import { renderPostText } from 'helpers/postHelpers'

import { type IProps } from './TextPostWrapper.types'

export const TextPostWrapper = ({ dataQuery, postData, postIndex }: IProps) => {
    const previewData = usePreviewContext()

    const handleWrapperClick: React.MouseEventHandler<HTMLDivElement> = (e) => {
    if ((e.target as HTMLElement).closest('a')) return; // <-- ignore link clicks
    const {
        minimized,
        updateSelectedPost,
        handleMinimize,
        addModal,
    } = previewData;

    if (minimized) {
        updateSelectedPost(postIndex, 0, 'text', postData, dataQuery);
        handleMinimize(false);
    } else {
        addModal(postIndex, 0, 'text', postData, dataQuery);
    }
    };

    return (
        <div
            className={
                'post__files__file post__files__file--img post__files__file--no-media'
            }
            id={postData.id.toString()}
            onClick={handleWrapperClick}
        >
            <p>{renderPostText(postData.body ?? '', postData.tags)}</p>
        </div>
    )
}
